<template>
    <div class="fixed inset-0 z-[99998] bg-black/20 animate-[confirm-animate-background_0.2s]"></div>
    <div class="fixed top-[30%] left-1/2 -translate-x-1/2 -translate-y-[30%] w-[300px] p-0 bg-white border border-gray-300 shadow-lg z-[99999] rounded animate-[confirm-animate_0.2s]">
        <div class="p-4" role="dialog" aria-labelledby="modal-title">
           
            <div class="text-start py-4 px-2">
                {{ message }}
            </div>

            <div class="grid grid-cols-2 gap-3 p-4">
                <button @click="$emit('cancel')" class="w-full px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-900 transition-colors">{{ $t("general.no") }}</button>
                <button @click="$emit('confirm')" class="w-full px-4 py-2 bg-primary-500 text-on-primary rounded hover:bg-primary-600 transition-colors">{{ $t("general.yes") }}</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { audioBeepSound } from './utils';


// 1. Define Props Interface
interface Props {
    message: string;
}

// 2. Define Emits Interface (if necessary, though defineEmits is often enough)
// The events carry no payload, so we just define the allowed event names.
const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'cancel'): void;
}>();

// Use the interface for defining props
defineProps<Props>();

onMounted(()=>{
    audioBeepSound().play();
})
</script>

<style lang="scss" scoped>
@keyframes confirm-animate {
    0%   {margin-top:-200px; opacity:0;}
    100% {margin-top: 0; opacity:1;}
}

@keyframes confirm-animate-background {
    0%   {background: rgba(0, 0, 0, 0)}
    100% {background: rgba(0, 0, 0, 0.08)}
}

#_audio_beep_sound_ {
    display: none;
    opacity: 0;
}
</style>